module.exports = __webpack_public_path__ + "img/img_02.cc6a14f9.png";